<template>
    <section v-if="poll">
        <h3>{{poll.name}}</h3>
        <b-field grouped group-multiline>
            <b-select v-model="perPage" @input="getData">
                <option value="5">5 por página</option>
                <option value="10">10 por página</option>
                <option value="15">15 por página</option>
                <option value="20">20 por página</option>
            </b-select>
            <div class="control" v-if="$auth.check(['super','admin','root'])">
                <router-link class="button is-success" :to="{name: 'CreateQuestion'}">
                    Nuevo Registro
                </router-link>
            </div>
        </b-field>



        <b-table
                :data="data"
                paginated
                :loading="loading"
                :per-page="perPage"
                backend-pagination
                default-sort="id"
                backend-sorting
                :current-page="currentPage"
                :total="total"
                @sort="sorted"
                @page-change="pageChange">
            <template slot-scope="props">
                <b-table-column label="Acciones">
                    <action-buttons :row="props.row" primary-key="uuid" show edit delete @deleteData="getData" model="Question" url="ivr/question">
                        <template slot-scope="item">
                            <show-question :question="item.item"></show-question>
                        </template>
                    </action-buttons>
                </b-table-column>
                <b-table-column field="content" label="Contenido" sortable>
                    {{props.row.content}}
                </b-table-column>
                <b-table-column field="order" label="Orden" sortable>
                    {{props.row.order}}
                </b-table-column>
                <b-table-column field="type" label="Tipo " sortable>
                    {{props.row.type}}
                </b-table-column>
            </template>
        </b-table>
    </section>
</template>

<script>
    export default {
        name: "Show",
        props:{
            poll: {
                required: true,
                type: Object,
            }
        },
        data() {
            return {
                data: [

                ],
                currentPage: 1,
                perPage: 10,
                total: 0,
                order: 'desc',
                field: 'id',
                loading: false
            }
        },
        created() {
            this.prepareComponent()
        },
        methods: {
            prepareComponent() {
                this.getData()
            },
            sorted(field, order) {
                this.field = field;
                this.order = order;
                this.getData()
            },
            pageChange(page) {
                this.currentPage = page;
                this.getData()
            },
            getData() {
                this.loading = true
                this.$http.get(`ivr/question/?poll=${this.poll.uuid}`, {
                    params: {
                        pagesize: this.perPage,
                        page: this.currentPage,
                        field: this.field,
                        sorting: this.order,
                    }
                }).then(response => {
                    this.loading = false;
                    let res = response.data;
                    this.data = res.data;
                    this.total = res.total
                }, error => {
                    this.loading = false;
                    Toast.danger(error.response.data.message)
                })
            }
        }
    }
</script>

<style scoped>

</style>